
        import type { TemplateResult, TemplateRootPropsForTag } from 'Components/types';
type relatedItemsRTRootProps = TemplateRootPropsForTag<'div'>;
import { createElement as _createElement } from 'preact';
import { map as _map } from 'Utils/array';
import _translate from 'Utils/translate';
export default function relatedItemsRT(): TemplateResult<relatedItemsRTRootProps> {
    function repeatItems1(items, itemsIndex) {
        return [items(function () {
                function scopeImage1(notesApplied, i, iIndex) {
                    var image = `image${ i }`;
                    return [this[image] ? _createElement('img', {
                            'className': 'lazy entered loaded product-grid-image-carousel-item',
                            'src': this.imageOrDefault(this.resizeImage(this[image])),
                            'alt': this.removeHTML(this.title),
                            'onError': this.onImageError,
                            'key': '22321'
                        }) : null];
                }
                function repeatI2(notesApplied, i, iIndex, image) {
                    return scopeImage1.apply(this, [
                        notesApplied,
                        i,
                        iIndex
                    ]);
                }
                function scopeImage3(notesApplied, i, iIndex) {
                    var image = `image${ i }`;
                    return [this[image] ? _createElement('span', {
                            'className': 'product-grid-image-carousel-scrollbar-item ' + (i === '' ? 'active' : ''),
                            'key': '34901'
                        }) : null];
                }
                function repeatI4(notesApplied, i, iIndex, image) {
                    return scopeImage3.apply(this, [
                        notesApplied,
                        i,
                        iIndex
                    ]);
                }
                function mergeProps(inline, external) {
                    var res = Object.assign({}, inline, external);
                    if (inline.hasOwnProperty('style')) {
                        res.style = _.defaults(res.style, inline.style);
                    }
                    if (inline.hasOwnProperty('className') && external.hasOwnProperty('className')) {
                        res.className = external.className + ' ' + inline.className;
                    }
                    return res;
                }
                function repeatI6(notesApplied, i, iIndex) {
                    return _createElement('span', {
                        'key': i,
                        'className': 'jdgm-star jdgm--' + (!(this.review_average - i) || this.review_average - i < 0.25 ? 'off' : this.review_average - i < 0.75 ? 'half' : 'on')
                    });
                }
                function repeatWarranty7(notesApplied, warranty, warrantyIndex) {
                    return _createElement('span', {}, [_createElement('svg', {
                            'width': '12',
                            'height': '15',
                            'viewBox': '0 0 12 15',
                            'fill': 'none',
                            'xmlns': 'http://www.w3.org/2000/svg',
                            'key': '55540'
                        }, _createElement('path', {
                            'fillRule': 'evenodd',
                            'clipRule': 'evenodd',
                            'd': 'M5.92788 1.35924C4.69495 2.43478 2.88071 3.33363 1.33333 3.33363V8.0003C1.33333 9.49092 1.8472 10.5743 2.65783 11.4046C3.48662 12.2534 4.65582 12.8668 5.99761 13.3301C6.00265 13.3319 6.00767 13.3337 6.01267 13.3356C7.34939 12.8691 8.51535 12.2545 9.34259 11.4058C10.1528 10.5745 10.6667 9.49089 10.6667 8.0003V3.33363C9.11981 3.33363 7.31227 2.44194 6.07206 1.35919C6.05179 1.34249 6.02631 1.33333 6 1.33333C5.97366 1.33333 5.94817 1.34251 5.92788 1.35924ZM5.06028 0.346767C5.32224 0.122964 5.65546 0 6 0C6.34454 0 6.67776 0.122964 6.93972 0.346767C6.94164 0.348413 6.94356 0.35007 6.94547 0.351738C8.03848 1.30734 9.5486 2.0003 10.6667 2.0003C11.0203 2.0003 11.3594 2.14078 11.6095 2.39082C11.8595 2.64087 12 2.98001 12 3.33363V8.0003C12 9.84305 11.3472 11.2594 10.2974 12.3365C9.26577 13.3949 7.88043 14.0965 6.44609 14.5965C6.44427 14.5971 6.44245 14.5977 6.44063 14.5984C6.15311 14.6958 5.84104 14.6922 5.556 14.5882C4.12007 14.0917 2.73518 13.3923 1.70383 12.336C0.652805 11.2596 0 9.84301 0 8.0003V3.33363C0 2.98001 0.140476 2.64087 0.390524 2.39082C0.640573 2.14078 0.979711 2.0003 1.33333 2.0003C2.45093 2.0003 3.96774 1.30112 5.05474 0.351558C5.05658 0.349951 5.05843 0.348354 5.06028 0.346767Z',
                            'fill': '#AF3939'
                        }), _createElement('path', {
                            'fillRule': 'evenodd',
                            'clipRule': 'evenodd',
                            'd': 'M8.47141 5.52886C8.73175 5.7892 8.73175 6.21132 8.47141 6.47166L5.80474 9.13833C5.54439 9.39868 5.12228 9.39868 4.86193 9.13833L3.5286 7.805C3.26825 7.54465 3.26825 7.12254 3.5286 6.86219C3.78895 6.60184 4.21105 6.60184 4.4714 6.86219L5.33333 7.72412L7.52859 5.52886C7.78894 5.26851 8.21106 5.26851 8.47141 5.52886Z',
                            'fill': '#AF3939'
                        }))], ' ', this.removeHTML(warranty), '\n          ');
                }
                function scopeShopPayIdShopPayMeta8(notesApplied) {
                    var shopPayId = this.variant_ids && this.variant_ids.length ? this.variant_ids[0] : this.id;
                    var shopPayMeta = window.Convermax.Shopify.getShopPayText(this.price, shopPayId, !this.out_of_stock, window.Convermax.shopPayTerms);
                    return [shopPayId && shopPayMeta ? _createElement('form', {
                            'className': 'product-shop-pay-message cm_shop-pay-terms-form',
                            'key': '131031'
                        }, _createElement('input', {
                            'type': 'hidden',
                            'name': 'id',
                            'value': shopPayId
                        }), _createElement('input', {
                            'type': 'hidden',
                            'name': 'quantity',
                            'value': '1'
                        }), _createElement('shopify-payment-terms', {
                            'variant-id': shopPayId,
                            'shopify-meta': shopPayMeta
                        })) : null];
                }
                function scopeNotesApplied9() {
                    var notesApplied = this.UnifiedNotes && isVehicleSelected;
                    return _createElement('div', { 'className': 'product-grid-col' }, _createElement('div', { 'className': 'product-grid-item' }, _createElement('div', { 'className': 'product-badges' }, !this.out_of_stock ? [
                        this.is_new ? _createElement('span', {
                            'className': 'new',
                            'key': '1791'
                        }, 'NEW') : null,
                        this.is_on_sale && window.Convermax.displaySale ? _createElement('span', {
                            'className': 'on-sale',
                            'key': '1793'
                        }, 'SALE') : null,
                        this.is_low_inventory ? _createElement('span', {
                            'className': 'low-stock',
                            'key': '1795'
                        }, 'LOW STOCK') : null
                    ] : null, this.out_of_stock && !this.custom_hide_sold_out_badge ? _createElement('span', {
                        'className': 'sold-out',
                        'key': '487'
                    }, _translate(`product_out_of_stock`)) : null), _createElement('div', { 'className': 'product-grid-item-content' }, _createElement('div', { 'className': 'image-wrapper pl-parent' }, _createElement('a', {
                        'href': this.url,
                        'className': 'product-grid-image cm_mobile-hide'
                    }, _createElement('img', {
                        'className': 'lazy first-image entered loaded',
                        'src': this.imageOrDefault(this.resizeImage(this.image)),
                        'alt': this.removeHTML(this.title),
                        'onError': this.onImageError
                    }), this.image2 ? _createElement('img', {
                        'className': 'lazy secondary-image small--hide entered loaded',
                        'src': this.resizeImage(this.image2),
                        'alt': this.removeHTML(this.title),
                        'onError': e => this.onImageError(e, 'image2'),
                        'key': '987'
                    }) : null), _createElement('div', {
                        'className': 'product-grid-image-carousel-wrapper cm_desktop-hide',
                        'data-carousel-index': '0'
                    }, this.image3 ? _createElement('button', {
                        'type': 'button',
                        'aria-label': 'Previous image',
                        'className': 'product-grid-image-carousel-button product-grid-image-carousel-button_prev product-grid-image-carousel-button_hidden',
                        'onClick': e => window.Convermax.productCardCarousel(e, false),
                        'key': '1326'
                    }, [_createElement('svg', {
                            'width': '12',
                            'height': '7',
                            'viewBox': '0 0 12 7',
                            'fill': 'none',
                            'xmlns': 'http://www.w3.org/2000/svg',
                            'key': '16030'
                        }, _createElement('path', {
                            'fillRule': 'evenodd',
                            'clipRule': 'evenodd',
                            'd': 'M11.4227 6.42267C11.0972 6.74811 10.5696 6.74811 10.2442 6.42267L5.83342 2.01193L1.42267 6.42267C1.09723 6.74811 0.569598 6.74811 0.244161 6.42267C-0.081275 6.09723 -0.0812751 5.5696 0.244161 5.24416L5.24416 0.244158C5.5696 -0.0812787 6.09723 -0.0812788 6.42267 0.244158L11.4227 5.24416C11.7481 5.5696 11.7481 6.09723 11.4227 6.42267Z',
                            'fill': '#222222'
                        }))]) : null, _createElement.apply(this, [
                        'a',
                        {
                            'href': this.url,
                            'className': 'product-grid-image-carousel'
                        },
                        _map([
                            '',
                            '2',
                            3,
                            4,
                            5
                        ], repeatI2.bind(this, notesApplied))
                    ]), this.image3 ? _createElement('button', {
                        'type': 'button',
                        'aria-label': 'Next image',
                        'className': 'product-grid-image-carousel-button product-grid-image-carousel-button_next',
                        'onClick': e => window.Convermax.productCardCarousel(e, true),
                        'key': '2617'
                    }, [_createElement('svg', {
                            'width': '12',
                            'height': '7',
                            'viewBox': '0 0 12 7',
                            'fill': 'none',
                            'xmlns': 'http://www.w3.org/2000/svg',
                            'key': '28470'
                        }, _createElement('path', {
                            'fillRule': 'evenodd',
                            'clipRule': 'evenodd',
                            'd': 'M11.4227 6.42267C11.0972 6.74811 10.5696 6.74811 10.2442 6.42267L5.83342 2.01193L1.42267 6.42267C1.09723 6.74811 0.569598 6.74811 0.244161 6.42267C-0.081275 6.09723 -0.0812751 5.5696 0.244161 5.24416L5.24416 0.244158C5.5696 -0.0812787 6.09723 -0.0812788 6.42267 0.244158L11.4227 5.24416C11.7481 5.5696 11.7481 6.09723 11.4227 6.42267Z',
                            'fill': '#222222'
                        }))]) : null, this.image3 ? _createElement.apply(this, [
                        'div',
                        {
                            'className': 'product-grid-image-carousel-scrollbar',
                            'key': '3406'
                        },
                        _map([
                            '',
                            '2',
                            3,
                            4,
                            5
                        ], repeatI4.bind(this, notesApplied))
                    ]) : null)), _createElement('div', { 'className': 'text-wrapper' }, _createElement('div', { 'className': 'product-text-top' }, _createElement('p', mergeProps({ 'className': 'product-grid-brand' }, { dangerouslySetInnerHTML: { __html: typeof this.vendor === 'undefined' ? '' : this.vendor } })), [this.review_count ? _createElement('div', {
                            'className': 'jdgm-widget jdgm-preview-badge jdgm--done-setup',
                            'key': '40690'
                        }, _createElement('div', {
                            'className': 'jdgm-prev-badge',
                            'data-average-rating': this.review_average,
                            'data-number-of-reviews': this.review_count
                        }, _createElement.apply(this, [
                            'span',
                            { 'className': 'jdgm-prev-badge__stars' },
                            _map([
                                0,
                                1,
                                2,
                                3,
                                4
                            ], repeatI6.bind(this, notesApplied))
                        ]), _createElement('span', { 'className': 'jdgm-prev-badge__text' }, this.review_count, ' reviews'))) : null]), _createElement('p', { 'className': 'h4 product-grid-name' }, !this.is_promotional_item ? _createElement('a', mergeProps({
                        'href': this.url,
                        'className': 'h3 product-grid-link',
                        'key': '4765'
                    }, { dangerouslySetInnerHTML: { __html: typeof this.custom_title === 'undefined' ? '' : this.custom_title } })) : null, this.is_promotional_item ? _createElement('a', mergeProps({
                        'href': this.url,
                        'className': 'h3 product-grid-link',
                        'key': '5000'
                    }, { dangerouslySetInnerHTML: { __html: typeof this.title === 'undefined' ? '' : this.title } })) : null), this.sku && !this.hide_sku ? _createElement('p', {
                        'className': 'product-grid-sku',
                        'key': '5231'
                    }, _createElement('span', { 'className': 'product-grid-sku-label' }, 'SKU:'), ' ', this.removeHTML(this.sku), '\n        ') : null, this.convermax_warranty ? _createElement.apply(this, [
                        'p',
                        {
                            'className': 'product-grid-warranty',
                            'key': '5411'
                        },
                        _map(this.convermax_warranty, repeatWarranty7.bind(this, notesApplied))
                    ]) : null, this.interchange_string_plp || notesApplied ? _createElement('div', {
                        'className': 'cm_product-fitment-notes',
                        'key': '7404'
                    }, notesApplied ? [
                        this.add_notes_prefix ? [
                            _translate(`product_notes_prefix`),
                            _createElement('br', { 'key': '75511' })
                        ] : null,
                        '\n            ',
                        this.UnifiedNotes.map(n => n.replaceAll('\n', ' | ')).join(' | '),
                        '\n            ',
                        this.add_notes_prefix ? [
                            _createElement('br', { 'key': '77740' }),
                            _translate(`product_notes_postfix`)
                        ] : null
                    ] : null, !notesApplied ? _createElement('div', { 'key': '7907' }, _createElement('span', { dangerouslySetInnerHTML: { __html: typeof this.interchange_string_plp === 'undefined' ? '' : this.interchange_string_plp } })) : null) : null, isVehicleSelected && this.fitsTheVehicle && (this.fitsTheVehicle === 'yes' || this.fitsTheVehicle === 'no') ? _createElement('div', {
                        'className': 'product-grid-fitment-badge ' + (this.fitsTheVehicle === 'yes' ? 'product-grid-fitment-badge_fits' : 'product-grid-fitment-badge_not-fits'),
                        'key': '8130'
                    }, this.fitsTheVehicle === 'yes' ? [
                        [_createElement('svg', {
                                'width': '15',
                                'height': '15',
                                'viewBox': '0 0 15 15',
                                'fill': 'none',
                                'xmlns': 'http://www.w3.org/2000/svg',
                                'key': '85310'
                            }, _createElement('path', {
                                'fillRule': 'evenodd',
                                'clipRule': 'evenodd',
                                'd': 'M7.33333 1.33333C4.01962 1.33333 1.33333 4.01962 1.33333 7.33333C1.33333 10.647 4.01962 13.3333 7.33333 13.3333C10.647 13.3333 13.3333 10.647 13.3333 7.33333C13.3333 4.01962 10.647 1.33333 7.33333 1.33333ZM0 7.33333C0 3.28325 3.28325 0 7.33333 0C11.3834 0 14.6667 3.28325 14.6667 7.33333C14.6667 11.3834 11.3834 14.6667 7.33333 14.6667C3.28325 14.6667 0 11.3834 0 7.33333Z',
                                'fill': '#39AF43'
                            }), _createElement('path', {
                                'fillRule': 'evenodd',
                                'clipRule': 'evenodd',
                                'd': 'M9.80474 5.5286C10.0651 5.78895 10.0651 6.21106 9.80474 6.4714L7.13807 9.13807C6.87772 9.39842 6.45561 9.39842 6.19526 9.13807L4.86193 7.80474C4.60158 7.54439 4.60158 7.12228 4.86193 6.86193C5.12228 6.60158 5.54439 6.60158 5.80474 6.86193L6.66667 7.72386L8.86193 5.5286C9.12228 5.26825 9.54439 5.26825 9.80474 5.5286Z',
                                'fill': '#39AF43'
                            }))],
                        ' ',
                        _translate(`product_fits`)
                    ] : null, this.fitsTheVehicle === 'no' ? [
                        [_createElement('svg', {
                                'width': '15',
                                'height': '15',
                                'viewBox': '0 0 15 15',
                                'fill': 'none',
                                'xmlns': 'http://www.w3.org/2000/svg',
                                'key': '95970'
                            }, _createElement('path', {
                                'fillRule': 'evenodd',
                                'clipRule': 'evenodd',
                                'd': 'M7.33333 1.33333C4.01962 1.33333 1.33333 4.01962 1.33333 7.33333C1.33333 10.647 4.01962 13.3333 7.33333 13.3333C10.647 13.3333 13.3333 10.647 13.3333 7.33333C13.3333 4.01962 10.647 1.33333 7.33333 1.33333ZM0 7.33333C0 3.28325 3.28325 0 7.33333 0C11.3834 0 14.6667 3.28325 14.6667 7.33333C14.6667 11.3834 11.3834 14.6667 7.33333 14.6667C3.28325 14.6667 0 11.3834 0 7.33333Z',
                                'fill': '#FF0000'
                            }), _createElement('path', {
                                'fillRule': 'evenodd',
                                'clipRule': 'evenodd',
                                'd': 'M9.80474 4.86193C10.0651 5.12228 10.0651 5.54439 9.80474 5.80474L5.80474 9.80474C5.54439 10.0651 5.12228 10.0651 4.86193 9.80474C4.60158 9.54439 4.60158 9.12228 4.86193 8.86193L8.86193 4.86193C9.12228 4.60158 9.54439 4.60158 9.80474 4.86193Z',
                                'fill': '#FF0000'
                            }), _createElement('path', {
                                'fillRule': 'evenodd',
                                'clipRule': 'evenodd',
                                'd': 'M4.86193 4.86193C5.12228 4.60158 5.54439 4.60158 5.80474 4.86193L9.80474 8.86193C10.0651 9.12228 10.0651 9.54439 9.80474 9.80474C9.54439 10.0651 9.12228 10.0651 8.86193 9.80474L4.86193 5.80474C4.60158 5.54439 4.60158 5.12228 4.86193 4.86193Z',
                                'fill': '#FF0000'
                            }))],
                        ' ',
                        _translate(`product_not_fits`)
                    ] : null) : null, this.custom_sale_callout && window.Convermax.displaySale ? _createElement('div', mergeProps({
                        'className': 'product-sale-callout',
                        'key': '10854'
                    }, { dangerouslySetInnerHTML: { __html: typeof this.custom_sale_callout === 'undefined' ? '' : this.custom_sale_callout } })) : null)), _createElement('div', { 'className': 'bottom-section-product' }, this.giveaway_multiplier && window.Convermax.displayGiveaway ? _createElement('div', {
                        'className': 'product-giveaway-entry',
                        'key': '11187'
                    }, _createElement('span', {}, Math.round(this.giveaway_multiplier * this.price_slider), ' entries'), _createElement('span', {}, this.giveaway_multiplier, 'x')) : null, !this.is_promotional_item ? [
                        !this.out_of_stock && this.variant_ids.length === 1 ? _createElement('form', {
                            'action': '/cart/add',
                            'method': 'post',
                            'className': 'variants',
                            'data-product-id': this.id,
                            'encType': 'multipart/form-data',
                            'onClick': e => window.Convermax.addItemToCart(e, this.variant_ids[0]),
                            'key': '114581'
                        }, _createElement('input', {
                            'type': 'hidden',
                            'name': 'id',
                            'value': this.variant_ids
                        }), _createElement('input', {
                            'type': 'hidden',
                            'name': 'quantity',
                            'value': '1'
                        }), _createElement('button', {
                            'type': 'submit',
                            'name': 'add',
                            'data-add-to-cart': this.id,
                            'className': 'js-go-cart-add-to-cart add-to-cart button cta product-grid-button'
                        }, _createElement('span', {}, ' ', _translate(`product_add_to_cart`), ' - ', this.formatPrice(this.price), ' '))) : null,
                        !this.out_of_stock && this.variant_ids.length > 1 ? _createElement('div', { 'key': '114583' }, _createElement('a', {
                            'className': 'js-go-cart-add-to-cart add-to-cart button cta product-grid-button',
                            'href': this.url
                        }, _createElement('span', {}, ' ', _translate(`product_select_options`), ' - ', this.formatPrice(this.price), ' '))) : null,
                        this.out_of_stock ? _createElement('div', {
                            'className': 'klaviyo-button-container',
                            'key': '114585'
                        }, _createElement('button', {
                            'className': 'add-to-cart button cta klaviyo-bis-trigger',
                            'onClick': () => window.Convermax.openCustomKlaviyoDialog(this)
                        }, _createElement('span', {}, 'Notify me when available'))) : null
                    ] : null, this.is_promotional_item && this.button_text ? _createElement('div', { 'key': '12824' }, _createElement('a', {
                        'className': 'button cta product-grid-button',
                        'href': this.url
                    }, this.button_text)) : null), !window.Convermax.Shopify?.customerTags?.includes('wholesale') ? [scopeShopPayIdShopPayMeta8.apply(this, [notesApplied])] : null));
                }
                return scopeNotesApplied9.apply(this, []);
            }, { count: undefined })];
    }
    return _createElement('div', { 'className': 'cm_related-products product-recommendations__inner half_row_mobile page-width zoom-fade-animation half_row_mobile zoomFade-animation' }, _createElement('div', { 'className': 'section-header text-center cm_related-products-title-container' }, _createElement('h2', { 'className': 'cm_related-products-title' }, _translate(`related_items_title`))), _createElement.apply(this, [
        'div',
        { 'className': 'zoom-fade-animation grid grid--uniform grid--view-items use_align_height zoomFade-animation cm_related-products-list cmRepeater_items' },
        _map(this.items, repeatItems1.bind(this))
    ]));
}
        export const componentNames = []